// Module
var code = `<jsonforms-layout>
    <fieldset ng-disabled="vm.uiSchema.readOnly">
      <legend>{{vm.label}}</legend>
        <div ng-repeat="d in vm.resolvedData"
             ng-if="vm.fragment === undefined"
             class="jsf-control-array-container">
            <div class="jsf-control-array-element">
                <jsonforms schema="vm.arraySchema"
                           data="d"
                           uischema="vm.arrayUiSchema">
                </jsonforms>
            </div>
            <div class="jsf-control-array-element-delete">
                <input class="btn btn-primary"
                       ng-show="vm.supportsDelete"
                       type="button"
                       value="X"
                       ng-click="vm.deleteCallback(d)">
                </input>
            </div>
        </div>
        <div ng-repeat="d in vm.resolvedData[vm.fragment]"
             ng-if="vm.fragment !== undefined"
             class="jsf-control-array-container">
            <div class="jsf-control-array-element">
                <jsonforms schema="vm.arraySchema"
                           data="d"
                           uischema="vm.arrayUiSchema">
                </jsonforms>
            </div>
            <div class="jsf-control-array-element-delete">
                <div class="button dynamic-set-remove"
                   ng-show="vm.supportsDelete"
                   ng-click="vm.deleteCallback(d)"
                >
                  <span class="fa fa-times property-remove"></span>
                </div>
            </div>
        </div>
        <div ng-if="vm.isEmpty" class="array-empty">{{vm.emptyMsg}}</div>
        <div class="button menu-item-content type1 add-property"
             ng-show="vm.supportsSubmit"
             ng-click="vm.submitCallback()"
             ng-model="vm.submitElement"
         >
          <span class="fa fa-plus"></span>
          Add {{vm.buttonText}}
        </div>
    </fieldset>
</jsonforms-layout>
`;
// Exports
export default code;